import { call, put, takeEvery } from 'redux-saga/effects';

import { createFlashMessage } from '@components/Flash/redux';
import {
  getPlacementTestQuestions,
  postPlacementTestCorrection,
  postSendWelcomeMundoTechEmail
} from '@utils/api/quiz';
import { actionTypes } from './action-types';
import { fetchUser } from './actions';

function* getPlacementTestQuestionsSaga() {
  try {
    const { success, result } = yield call(getPlacementTestQuestions);

    if (success) {
      yield put({
        type: actionTypes.getPlacementTestQuestionsComplete,
        payload: result || []
      });
    }
  } catch (e) {
    console.error('Error fetching placement test questions:', e);
    yield put(
      createFlashMessage({
        type: 'error',
        message:
          'Falha ao trazer teste de nivelamento. Tente novamente mais tarde.'
      })
    );
  }
}

function* postPlacementTestCorrectionSaga(action) {
  try {
    const { success, message } = yield call(
      postPlacementTestCorrection,
      action.payload
    );

    if (success) {
      yield put(
        createFlashMessage({
          type: 'success',
          message: 'Teste de nivelamento enviado com sucesso!',
          variables: { dismissible: true }
        })
      );
      yield put(fetchUser());
    } else {
      yield put(
        createFlashMessage({
          type: 'error',
          message:
            message ||
            'Falha ao enviar teste de nivelamento para correção. Tente novamente mais tarde.',
          variables: { dismissible: true }
        })
      );
    }
  } catch (e) {
    console.error('Error posting placement test correction:', e);
    yield put(
      createFlashMessage({
        type: 'error',
        message:
          'Falha ao enviar teste de nivelamento para correção. Tente novamente mais tarde.',
        variables: { dismissible: true }
      })
    );
  } finally {
    yield put({
      type: actionTypes.postPlacementTestCorrectionComplete
    });
  }
}

function* postSendWelcomeMundoTechEmailSaga() {
  try {
    yield call(postSendWelcomeMundoTechEmail);
  } catch (e) {
    console.error('Error sending welcome MundoTech email:', e);
    yield put(
      createFlashMessage({
        type: 'error',
        message:
          'Falha ao enviar email de boas vindas para MundoTech. Tente novamente mais tarde.',
        variables: { dismissible: true }
      })
    );
  }
}

export function createPlacementTestSaga(types) {
  return [
    takeEvery(types.getPlacementTestQuestions, getPlacementTestQuestionsSaga),
    takeEvery(
      types.postPlacementTestCorrection,
      postPlacementTestCorrectionSaga
    ),
    takeEvery(
      types.postSendWelcomeMundoTechEmail,
      postSendWelcomeMundoTechEmailSaga
    )
  ];
}
